(function() {
  function styleShopifyForm() {
    const formEmbed = document.querySelector('shopify-forms-embed#app-embed');
    
    if (!formEmbed) {
      setTimeout(styleShopifyForm, 100);
      return;
    }

    const shadowRoot = formEmbed.shadowRoot;
    
    if (!shadowRoot) {
      setTimeout(styleShopifyForm, 100);
      return;
    }

    if (shadowRoot.querySelector('#custom-form-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'custom-form-styles';
    style.textContent = `
      :host {
        --forms-body-font: normal 400 14px "Jubilee Golden", sans-serif !important;
        --forms-heading-font: normal 400 22px "Jubilee Golden", sans-serif !important;
        --inline-container-max-width: 600px !important;
        --container-max-w: 600px !important;
      }

      ._formContainer_1q1d2_30 {
        max-width: 600px !important;
        width: 100% !important;
        margin: 0 auto !important;
      }

      * {
        font-family: "Jubilee Golden", sans-serif !important;
      }

      ._formFieldset_cit2d_82 {
        display: flex !important;
        flex-direction: row !important;
        gap: 1rem !important;
        align-items: flex-start !important;
        height: 56px !important;
        min-height: 56px !important;
        max-height: 56px !important;
        overflow: visible !important;
        position: relative !important;
      }

      ._formFieldContainer_1mxsl_5,
      ._selectContainer_12thd_6 {
        flex: 1 !important;
        margin-bottom: 0 !important;
        min-width: 0 !important;
        height: 56px !important;
        min-height: 56px !important;
        max-height: 56px !important;
        overflow: visible !important;
        position: relative !important;
      }

      ._label_12thd_10 {
        display: none !important;
      }

      ._selectContainer_12thd_6,
      ._gridItemContent_1q1d2_257,
      ._formContainer_1q1d2_30,
      ._gridItem_1q1d2_172,
      ._grid_1q1d2_148,
      section {
        overflow: visible !important;
        clip-path: none !important;
      }

      ._formInputField_nag3b_7,
      ._selectToggle_12thd_25 {
        border-radius: 12px !important;
        padding: 1rem !important;
        font-size: 16px !important;
        height: 56px !important;
        min-height: 56px !important;
        max-height: 56px !important;
        box-sizing: border-box !important;
        flex-shrink: 0 !important;
      }

      ._selectToggle_12thd_25 {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        text-align: left !important;
      }

      /* Dropdown and all children */
      div[class*="dropdownContainer"],
      div[class*="dropdownContainer"] *,
      ._dropdownContainer_12thd_63,
      ._dropdownContainer_12thd_63 *,
      [class*="showDownwards"],
      [class*="showDownwards"] * {
        max-height: none !important;
        height: auto !important;
        overflow: visible !important;
      }

      ._selectToggleText_12thd_25:empty::before {
        content: 'Instructor or Player?' !important;
        color: #20202080 !important;
      }

      ._formSubmitButton_cit2d_96 {
        all: revert !important;  /* Revert the 'all: unset' */
        flex-shrink: 0 !important;
        flex-grow: 0 !important;
        background-color: #e91e8c !important;
        color: #fff !important;
        border-radius: 12px !important;
        padding: 1rem 2rem !important;
        font-size: 16px !important;
        text-transform: uppercase !important;
        font-family: "Jubilee Golden", sans-serif !important;
        white-space: nowrap !important;
        height: 56px !important;
        min-height: 56px !important;
        max-height: 56px !important;
        line-height: 1 !important;
        box-sizing: border-box !important;
        align-self: flex-start !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        border: none !important;
        cursor: pointer !important;
    }

      @media (max-width: 768px) {
        ._formFieldset_cit2d_82 {
          flex-direction: column !important;
          height: auto !important;
          max-height: none !important;
        }
        ._formSubmitButton_cit2d_96 {
          width: 100% !important;
        }
        ._formFieldContainer_1mxsl_5,
        ._selectContainer_12thd_6 {
          margin-bottom: 1rem !important;
        }
      }

      /* Make email field container stack vertically */
._formFieldContainer_1mxsl_5 {
  flex: 1 !important;
  margin-bottom: 0 !important;
  min-width: 0 !important;
  height: auto !important;  /* Changed from 56px */
  min-height: 56px !important;
  max-height: none !important;  /* Allow to expand for errors */
  overflow: visible !important;
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;  /* Stack children vertically */
}

/* Input field itself stays 56px */
._formInputField_nag3b_7 {
  border-radius: 12px !important;
  padding: 1rem !important;
  font-size: 16px !important;
  height: 56px !important;
  min-height: 56px !important;
  max-height: 56px !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;
}

/* Error message styling */
._formFieldContainer_1mxsl_5 > * {
  width: 100% !important;
}
    `;

    shadowRoot.appendChild(style);

    const shadowObserver = new MutationObserver(function() {
      const dropdown = shadowRoot.querySelector('[class*="dropdownContainer"]');
      const selectButton = shadowRoot.querySelector('._selectToggle_12thd_25');
      
      if (dropdown && selectButton && !dropdown.hasAttribute('data-positioned')) {
        console.log('🎯 Dropdown detected!');
        console.log('Dropdown element:', dropdown);
        console.log('Dropdown computed height:', window.getComputedStyle(dropdown).height);
        console.log('Dropdown computed max-height:', window.getComputedStyle(dropdown).maxHeight);
        console.log('Dropdown children count:', dropdown.children.length);
        
        // Log all children
        Array.from(dropdown.children).forEach((child, index) => {
          console.log(`Child ${index}:`, child);
          console.log(`Child ${index} height:`, window.getComputedStyle(child).height);
          console.log(`Child ${index} max-height:`, window.getComputedStyle(child).maxHeight);
        });
        
        const buttonRect = selectButton.getBoundingClientRect();
        
        // Aggressively style dropdown and all children
        dropdown.style.cssText = `
          position: fixed !important;
          top: ${buttonRect.bottom + 4}px !important;
          left: ${buttonRect.left}px !important;
          width: ${buttonRect.width}px !important;
          z-index: 999999 !important;
          max-height: none !important;
          height: auto !important;
          overflow: visible !important;
          background: white !important;
          border-radius: 8px !important;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
          border: 1px solid #ddd !important;
          padding: 0 !important;
        `;
        
        // Fix all children
        Array.from(dropdown.querySelectorAll('*')).forEach(child => {
          child.style.maxHeight = 'none';
          child.style.height = 'auto';
          child.style.overflow = 'visible';
        });
        
        dropdown.setAttribute('data-positioned', 'true');
        
        console.log('✅ Dropdown styled! New height:', window.getComputedStyle(dropdown).height);
        
        const updatePosition = () => {
          const newRect = selectButton.getBoundingClientRect();
          dropdown.style.top = `${newRect.bottom + 4}px`;
          dropdown.style.left = `${newRect.left}px`;
          dropdown.style.width = `${newRect.width}px`;
        };
        
        window.addEventListener('scroll', updatePosition);
        window.addEventListener('resize', updatePosition);
      }
    });

    shadowObserver.observe(shadowRoot, {
      childList: true,
      subtree: true
    });

    console.log('✅ Form styles injected with ENHANCED dropdown logging!');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleShopifyForm);
  } else {
    styleShopifyForm();
  }

  const observer = new MutationObserver(function() {
    const formEmbed = document.querySelector('shopify-forms-embed#app-embed');
    if (formEmbed && formEmbed.shadowRoot && !formEmbed.shadowRoot.querySelector('#custom-form-styles')) {
      styleShopifyForm();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(styleShopifyForm, 500);
  setTimeout(styleShopifyForm, 1000);
  setTimeout(styleShopifyForm, 2000);
})();